import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, Validators } from '@angular/forms';
import { AuthService } from '@elight/client/shared/utility/auth';

@Component({
    selector: 'elight-reset-password-dialog',
    templateUrl: './reset-password-dialog.component.html',
    styleUrls: ['./reset-password-dialog.component.scss'],
})
export class ResetPasswordDialogComponent {
    public email = new FormControl('', [Validators.required, Validators.email]);
    public firebaseAuthErrorMessage = '';
    public resetPasswordEmailSent = false;

    constructor(
        private dialogRef: MatDialogRef<ResetPasswordDialogComponent>,
        private authService: AuthService
    ) {}

    public closeDialog(): void {
        this.dialogRef.close();
    }

    public sendResetPasswordEmail(): void {
        if (this.email.valid) {
            this.authService.resetPassword(this.email.value).subscribe(
                () => this.onResetPasswordSuccess(),
                (error) => this.onResetPasswordError(error)
            );
        }
    }

    private onResetPasswordSuccess(): void {
        this.resetPasswordEmailSent = true;
    }

    private onResetPasswordError(firebaseAuthError: any): void {
        this.firebaseAuthErrorMessage = firebaseAuthError.message;
    }
}
